import { DateWithSingleRangeValue } from "PFTypes";

export const isDateWithSingleRangeValue = (value: any): value is DateWithSingleRangeValue =>
  value && "start" in value && "end" in value;
